<script lang="ts">
  /**
   * Thanh trượt "Sơ đồ tách rời" — điều chỉnh mức tách rời các chi tiết (0..100%).
   * Nổi trên toolbar (giống MeasureBar). Kéo slider → onAmount(0..1) áp trực tiếp lên scene.
   */
  import Icon from './Icon.svelte';
  import { t } from '../i18n/index.svelte';

  let {
    amount,
    scopeCount = 0,
    onAmount,
    onClose,
  }: {
    /** mức hiện tại 0..1 */
    amount: number;
    /** số cụm đang tách (hiển thị ngữ cảnh). */
    scopeCount?: number;
    onAmount: (v: number) => void;
    onClose: () => void;
  } = $props();

  const pct = $derived(Math.round(amount * 100));
</script>

<div class="explode-bar">
  <div class="row">
    <span class="head"><Icon name="explode" size={16} /> {t('explode.title')}{#if scopeCount > 0} · {t('sel.count', { n: scopeCount })}{/if}</span>
    <button class="close" title={t('common.close')} aria-label={t('common.close')} onclick={onClose}>
      <Icon name="close" size={16} />
    </button>
  </div>

  <label class="slider">
    <span class="lbl">{t('explode.amount')} — {pct}%</span>
    <input
      type="range"
      min="0"
      max="100"
      step="1"
      value={pct}
      aria-label={t('explode.amount')}
      oninput={(e) => onAmount(+e.currentTarget.value / 100)}
    />
  </label>
</div>

<style>
  .explode-bar {
    position: absolute;
    right: var(--space-md);
    bottom: 84px;
    z-index: var(--z-panel);
    width: 240px;
    padding: var(--space-sm) var(--space-md);
    background: var(--color-surface-glass);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-control);
    box-shadow: var(--shadow-panel);
    backdrop-filter: blur(10px);
  }
  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: var(--space-xs);
  }
  .head {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-weight: 700;
    color: var(--color-text-primary);
  }
  .close {
    border: none;
    background: transparent;
    color: var(--color-text-secondary);
    cursor: pointer;
    padding: 4px;
    border-radius: 6px;
  }
  .close:hover {
    color: var(--color-error);
  }
  .slider {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .lbl {
    font-size: var(--font-size-caption);
    font-weight: 600;
    color: var(--color-text-secondary);
  }
  .slider input[type='range'] {
    width: 100%;
    accent-color: var(--color-primary);
    cursor: pointer;
  }

  @media (max-width: 767px) {
    .explode-bar {
      right: var(--space-md);
      left: var(--space-md);
      width: auto;
      bottom: 140px;
    }
  }
</style>
